export default {
  sm: `
  데이터센터 각은 방대한 데이터의 저장과 분석을
  통해 수많은 가치를 창출하는 차세대 데이터센터의
  표본입니다.
  `,
  md: `
  데이터센터 각은 방대한 데이터의 저장과
  분석을 통해 수많은 가치를 창출하는 차세대
  데이터센터의 표본입니다.
  `,
  lg: `
  데이터센터 각은 방대한 데이터의 저장과 분석을
  통해 수많은 가치를 창출하는 차세대
  데이터센터의 표본입니다.
  `,
  xxl: `
  데이터센터 각은 방대한 데이터의 저장과 분석을 통해
  수많은 가치를 창출하는 차세대 데이터센터의 표본입니다.
  `
};
